/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Palette_RecentInputs */

const en_palette_recent = /** @type {(inputs: Palette_RecentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recent`)
};

/**
* | output |
* | --- |
* | "Recent" |
*
* @param {Palette_RecentInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const palette_recent = /** @type {((inputs?: Palette_RecentInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Palette_RecentInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_palette_recent(inputs)
});